import { Drawer } from '@/components';
import { useProject } from '@/features/project/_hooks/project';
import { useId } from '@/hooks';
import type { FC } from 'react';
import type { z } from 'zod';
import type { SubProjectsModel } from '../../../_models/sub-project';
import { useProjectDetailDrawerState } from '../../_components/ProjectDrawerStateProvider';
import { BelanjaForm } from './BelanjaForm';
import { ExpenditureItemForm } from './ExpenditureItemForm';

type Props = {
  fiscalYear: number;
  data?: z.infer<typeof SubProjectsModel.element> | undefined;
};

export const ExpenditureItemFormDrawer: FC<Props> = ({ fiscalYear }) => {
  const { id: projectId } = useId();
  const { drawerState, setDrawerState } = useProjectDetailDrawerState();
  const project = useProject(projectId);

  const openDrawer =
    drawerState.open && drawerState.type === 'expenditure-item';
  const mode = openDrawer ? drawerState.mode : undefined;
  const isEditing = openDrawer && drawerState.isEditing;

  const initialValues =
    (mode === 'Belanja'
      ? project.data?.indonesiaData?.belanjaProgram
      : project.data?.indonesiaData?.biayaTenaga
    )?.find((d) => isEditing && d.id === drawerState.id) ?? undefined;

  return (
    <Drawer
      open={openDrawer}
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnClose
    >
      {mode === 'Belanja' ? (
        <ExpenditureItemForm
          fiscalYear={fiscalYear}
          mode={mode}
          initialValues={initialValues}
          isEditing={isEditing}
        />
      ) : (
        <BelanjaForm
          fiscalYear={fiscalYear}
          initialValues={initialValues}
          isEditing={isEditing}
        />
      )}
    </Drawer>
  );
};
